export default __webpack_public_path__ + "static/media/01_RoweOil-Commercial-EschweilerPhotography_M1A0288_flat_Shadows.d7749925.jpg";